import { ApplicationConfig, provideZoneChangeDetection, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { brokerRoutes } from './app-broker.routes';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { providePurpleApiErrorManager, providePurpleLoader, provideUtilitiesCore } from '@purple-lib/purple-utilities';

export const appBrokerConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(brokerRoutes),

    ...provideUtilitiesCore(),
    
    ...providePurpleLoader(),
    ...providePurpleApiErrorManager(),//Importa HTTPCLIENT + INTERCEPTOR
    
    importProvidersFrom(
      NzDrawerModule,
      NzModalModule
    ),
    provideAnimationsAsync()
  ]
};
